<p><b>Обычный</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-toggle-switch formControlName="isEnabled"></pa-toggle-switch>
    </form>
</div>

<p><b>С подписью</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-toggle-switch 
            formControlName="isEnabled"
            label="Включить уведомления"></pa-toggle-switch>
    </form>
</div>

<p><b>С подсказкой</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-toggle-switch
            tooltip="Включите для получения уведомлений"
            label="Уведомления" 
            formControlName="isEnabled" 
            hint="Вы будете получать уведомления о новых сообщениях."></pa-toggle-switch>
    </form>
</div>

<p><b>Обязательный</b></p>
<div class="box">
    <form [formGroup]="form3">
        <pa-toggle-switch
            label="Согласие с условиями" 
            formControlName="isRequired" 
            hint="Необходимо согласиться с условиями использования."
        ></pa-toggle-switch>
    </form>
</div>

<p><b>Выключенный</b></p>
<div class="box">
    <form [formGroup]="form2">
        <pa-toggle-switch 
            label="Недоступная опция" 
            formControlName="isDisabled"></pa-toggle-switch>
    </form>
</div>


<p><b>Кастомные сообщения ошибок</b></p>
<div class="box">
    <form [formGroup]="form4">
        <pa-toggle-switch
            label="Согласие с условиями"
            formControlName="isRequired"
            hint="Необходимо согласиться с условиями использования."
            [customErrorMessages]="toggleErrorMessages"
        ></pa-toggle-switch>
    </form>
</div>